import React from 'react';
import { utcStringToLocalDate} from 'common';

const PaperworkEntryDetails = ({
    username,
    patientFullName,
    userFullName,
    physicianProductivityPoints,
    dos,
    createdOn,
    client,
    status
}) => {
    return (
        <div className="spc--bottom--tiny">
            <h4 className="type--small type--bold type--letterspace--wide type--uppercase spc--bottom--sml">Entry Details</h4>
        
            <p className="type--small"><span className="type--tiny type--color--light type--bold type--letterspace--wide type--uppercase spc--bottom--sml">Created By:</span> {userFullName} ({username})</p>           
            <p className="type--small"><span className="type--tiny type--color--light type--bold type--letterspace--wide type--uppercase spc--bottom--sml">Client:</span> {client}</p>                   
            <p className="type--small"><span className="type--tiny type--color--light type--bold type--letterspace--wide type--uppercase spc--bottom--sml">Patient:</span> {patientFullName}</p>
            <p className="type--small"><span className="type--tiny type--color--light type--bold type--letterspace--wide type--uppercase spc--bottom--sml">Status:</span> {status}</p>
            <p className="type--small"><span className="type--tiny type--color--light type--bold type--letterspace--wide type--uppercase spc--bottom--sml">Physician Productivity Points:</span> {physicianProductivityPoints.toFixed(2)}</p>
            <p className="type--small"><span className="type--tiny type--color--light type--bold type--letterspace--wide type--uppercase spc--bottom--sml">Date of Service:</span> {utcStringToLocalDate(dos)}</p>
            <p className="type--small"><span className="type--tiny type--color--light type--bold type--letterspace--wide type--uppercase spc--bottom--sml">Date Created:</span> {utcStringToLocalDate(createdOn)}</p>
        </div>
    )
}

export { PaperworkEntryDetails }


// WEBPACK FOOTER //
// ./src/modules/paperwork-entry/components/PaperworkEntryDetails.js